import { useCallback } from "react";

/**
 * GAを削除したが、今後の分析処理の初期化時に使う
 */
export function initAnalytics(appVersion: string) {
  console.log("==> [GA] version:", appVersion);
}

export const useAnalytics = () => {
  const sendEvent = useCallback(
    (eventName: Gtag.EventNames | string, eventParams?: Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams) => {
      // if (!gtag) {
      //   return;
      // }
      if (__IS_LOCAL__) {
        console.log("==> [GA] event:", eventName);
        if (eventParams) {
          console.table(eventParams);
        }
      }
      // gtag("event", eventName, { ...eventParams, app_version: __APP_VERSION__ });
    },
    [],
  );

  const sendSearchSuggestEvent = useCallback(() => {
    sendEvent("search_suggest");
  }, [sendEvent]);

  const sendSearchEvent = useCallback(() => {
    sendEvent("search");
  }, [sendEvent]);

  const sendChatEvent = useCallback(() => {
    sendEvent("chat");
  }, [sendEvent]);

  const sendDocumentChatEvent = useCallback(() => {
    sendEvent("document_chat");
  }, [sendEvent]);

  return {
    sendChatEvent,
    sendSearchEvent,
    sendSearchSuggestEvent,
    sendDocumentChatEvent,
  };
};
